// apps/web/src/components/checklist/RewardBanner.tsx
import type { Reward } from '@homework-app/shared';

interface Props {
  reward: Reward | null;
  allApproved: boolean;
  completedCount: number;
  totalCount: number;
}

export function RewardBanner({ reward, allApproved, completedCount, totalCount }: Props) {
  if (!reward) return null;

  if (allApproved && reward.earned) {
    return (
      <div className="reward-banner earned">
        <span className="reward-icon">&#127942;</span>
        <div>
          <strong>Checklist complete!</strong>
          <p>You earned: {reward.reward_text}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="reward-banner in-progress">
      <div>
        <strong>{completedCount} of {totalCount} done</strong>
        <p>Complete all items to earn: {reward.reward_text}</p>
      </div>
    </div>
  );
}
